import React from 'react';
import s from './AdditionalRibbons.scss';
import {ConditionalRender} from '../../ConditionalRender/ConditionalRender';
import {RibbonPlacementId} from '../../../../types/galleryTypes';

export enum AdditionalRibbonsDataHook {
  RibbonOnImage = 'AdditionalRibbonsDataHook.RibbonOnImage',
  RibbonOnProductInfo = 'AdditionalRibbonsDataHook.RibbonOnProductInfo',
}

export interface IAdditionalRibbonsProps {
  ribbons: string[];
  placement: RibbonPlacementId;
}

export const AdditionalRibbons: React.FC<IAdditionalRibbonsProps> = ({ribbons, placement}) => {
  const dataHook =
    placement === RibbonPlacementId.OnImage
      ? AdditionalRibbonsDataHook.RibbonOnImage
      : AdditionalRibbonsDataHook.RibbonOnProductInfo;

  const conditionalRenderBy =
    placement === RibbonPlacementId.OnImage
      ? 'shouldShowAdditionalRibbonsOnImage'
      : 'shouldShowAdditionalRibbonsOnProductInfo';

  return (
    <>
      {ribbons.map((ribbon, index) => (
        <ConditionalRender key={index} by={conditionalRenderBy} className={s.additionalRibbonWrapper}>
          <div className={s.additionalRibbon} data-hook={dataHook}>
            {ribbon}
          </div>
        </ConditionalRender>
      ))}
    </>
  );
};
